import { Label } from '@cian/ui-kit';

import { type FC } from 'react';

import styles from './SeriaPlusLabel.css';

type SeriaPlusLabelProps = {
  trackLabelClick(): void;
};

export const SeriaPlusLabel: FC<SeriaPlusLabelProps> = props => (
  <div className={styles['container']}>
    <Label
      background="#fc4c02"
      color="text-inverted-default"
      data-testid="carousel-labels.seria-plus"
      onClick={props.trackLabelClick}
    >
      Серия плюс
    </Label>
  </div>
);
